/**
 * TanStack Query hooks for `postback-as-api-endpoint`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	postbackAsApiEndpointQueryKeys,
	type CreatePostbackAsApiEndpointBody,
	type ListPostbackAsApiEndpointResponse,
	type PostbackAsApiEndpointRow,
} from "./api";

export function usePostbackAsApiEndpointList(): UseQueryResult<ListPostbackAsApiEndpointResponse, Error> {
	return useQuery({
		queryKey: postbackAsApiEndpointQueryKeys.list(),
		queryFn: list,
	});
}

export function usePostbackAsApiEndpointCreate(): UseMutationResult<PostbackAsApiEndpointRow, Error, CreatePostbackAsApiEndpointBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: postbackAsApiEndpointQueryKeys.all });
		},
	});
}

export function usePostbackAsApiEndpointDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: postbackAsApiEndpointQueryKeys.all });
		},
	});
}
